module.exports = __webpack_public_path__ + "static/img/exhibitor_top_cn.4c4f52d9.png";